import axios from 'axios';
import { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { AuthCardBanner } from '../../components/AuthCardBanner';
import { TextInput } from '../../components/Inputs';
import { GradientButton } from '../../components/Buttons';

function ResetCredential() {
  useEffect(() => {
    document.title = 'Reset Password | PromptSlate';
  }, []);
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate('/dashboard');
    }
  }, [navigate]);

  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const emailParam = queryParams.get('email');
    const tokenParam = queryParams.get('token');

    setEmail(emailParam || '');
    setToken(tokenParam || '');
  }, []);

  const handlePasswordReset = async (event: React.FormEvent<HTMLFormElement>) => {
    setErrorMessage('');
    event.preventDefault();

    if (confirmPassword !== password) {
      setErrorMessage('Password does not match');
      return;
    }

    try {
      const response = await axios.patch(`${process.env.REACT_APP_API_URL}/auth/reset-password`, {
        email,
        token,
        password,
      });

      // Store the token in localstorage
      localStorage.setItem('authToken', response.data.token);
      navigate('/dashboard');
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        // Error response from the server
        setErrorMessage(error.response.data.message || 'Something went wrong!');
      } else {
        // Network or unknown error
        setErrorMessage('An unknown error occurred.');
      }
    }
  };

  return (
    <div className="flex flex-row items-center justify-center h-screen bg-[#f8f7f2]">
      <div className="flex flex-row items-stretch w-4/12 h-[500px] bg-[#fcfcf7] border rounded-xl p-6 shadow-sm">
        <AuthCardBanner />
        <div className="w-7/12 flex flex-col justify-center p-4 pl-12">
          <span className="font-playfair text-xl font-semibold">Set a new password</span>
          {errorMessage && <div className="text-red-600 text-sm mt-5">{errorMessage}</div>}
          <form onSubmit={handlePasswordReset} className="flex flex-col">
            <TextInput
              type="password"
              placeholder="Enter a secure password"
              className="mt-5"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <TextInput
              type="password"
              placeholder="Confirm Password"
              className="mt-5"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              required
            />
            <GradientButton type="submit" className="mt-5 w-full">
              Reset password
            </GradientButton>
          </form>
          <span className="text-sm mt-6 text-[#606060]">
            <NavLink to="/login">or login instead</NavLink>
          </span>
        </div>
      </div>
    </div>
  );
}

export default ResetCredential;
